import getMomaColorFromHexColor from "modules/colorSchemes/helpers/getMomaColorfromHexColor";
import { CustomizedColorSchemeForm } from "modules/colorSchemes/schemas/formSchemas";
import getFixedColors from "./getFixedColors";
import { ColorScheme } from "modules/preview/schemas/colorSchemesSchemas";

const getFullColorSchemeFromFormValues = ({
  name,
  description,
  color_12,
  color_13,
  color_14,
  color_15,
}: CustomizedColorSchemeForm) => {
  return {
    name,
    description,
    colors: {
      ...getFixedColors(),
      color_12: getMomaColorFromHexColor(color_12),
      color_13: getMomaColorFromHexColor(color_13),
      color_14: getMomaColorFromHexColor(color_14),
      color_15: getMomaColorFromHexColor(color_15),
    },
  } as ColorScheme;
};
export default getFullColorSchemeFromFormValues;
